import {ISelectRangeOption} from "@pg-design/select-range-module";

export const ROOM_SELECTOR_OPEN_ENDED_VALUE = 5;

export const ROOM_SELECTOR_OPTIONS: ISelectRangeOption[] = [
    {id: "1", label: "1", value: 1},
    {id: "2", label: "2", value: 2},
    {id: "3", label: "3", value: 3},
    {id: "4", label: "4", value: 4},
    {id: "5", label: "5+", value: ROOM_SELECTOR_OPEN_ENDED_VALUE}
];
import {ISelectRangeOption} from "@pg-design/select-range-module";

export const ROOM_SELECTOR_OPEN_ENDED_VALUE = 5;

export const ROOM_SELECTOR_OPTIONS: ISelectRangeOption[] = [
    {id: "1", label: "1", value: 1},
    {id: "2", label: "2", value: 2},
    {id: "3", label: "3", value: 3},
    {id: "4", label: "4", value: 4},
    {id: "5", label: "5+", value: ROOM_SELECTOR_OPEN_ENDED_VALUE}
];
